<ol class="breadcrumb">
    @for (state of breadcrumbs; track identify(indexOfBreadcrumb); let indexOfBreadcrumb = $index) {
        <li [ngClass]="{ active: indexOfBreadcrumb === breadcrumbs.length - 1 }">
            <a [uiSref]="getStateName(state)" [uiParams]="getStateParams()" [title]="state.breadcrumbTitle | translate">{{
                state.breadcrumbTitle | translate
            }}</a>
        </li>
    }
</ol>
